import React from 'react';
import { RouterProvider } from 'react-router-dom';
import { Loader } from './components';
import { Provider } from 'react-redux';
import { reduxStore, persistor } from './redux/store';
import { PersistGate } from 'redux-persist/integration/react'
import Router from './routes';


function App() {
    return (
      <React.Suspense fallback={<Loader />}>
        <RouterProvider router={Router} />
      </React.Suspense>
  );
}


// Wrapper for Provider redux
const AppWrapper = () => {
  return (
    <Provider store={reduxStore}>
      <PersistGate loading={'Loading...'} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  );
};

export default AppWrapper;
